import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { HistoricalCustomerRepresentativeModalComponent } from './historical-customer-representative-modal.component';
import { HistoricalCustomerRepresentativeComponent } from './historical-customer-representative.component';

@NgModule({
    declarations: [
        HistoricalCustomerRepresentativeComponent,
        HistoricalCustomerRepresentativeModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        HistoricalCustomerRepresentativeComponent,
        HistoricalCustomerRepresentativeModalComponent
    ]
})

export class HistoricalCustomerRepresentativeModule { }
